export default "__VITE_ASSET__729ab55f__"